module.exports = __webpack_public_path__ + "img/xmasParty17.66baf8b7.jpg";